import React, {useEffect, useState} from 'react'
import {Link, NavLink} from 'react-router-dom'
import styles from './Navbar.module.css'

const EventsNavbar = () => {
    const [showNavbar, setShowNavbar] = useState(true);
    const [previousScrollPos, setPreviousScrollPos] = useState(0);
    const Navbar = React.useRef(null);

    useEffect(() => {
        const currentScrollPos = window.pageYOffset;
        if(currentScrollPos >= 10 && previousScrollPos === 0) {
            //Add class to navbar
            Navbar.current.classList.add(styles.customnavbarHiddenWithOutTransition);
            setShowNavbar(false);
        }
        const handleScroll = () => {
            const currentScrollPos = window.pageYOffset;
            if (previousScrollPos > currentScrollPos) {
                setShowNavbar(true);
            } else {
                setShowNavbar(false);
            }
            setPreviousScrollPos(currentScrollPos);
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [previousScrollPos]);
    return (
        <nav ref={Navbar} className={[styles.customnavbar, styles.greenNavbar, `${showNavbar ? styles.navbarVisible : styles.customnavbarHidden}`].join(' ')}>
            <div className={styles.flexcenter}>
                <Link to={'/events/'} className={styles.brandmark}>
                    Leryon Events
                </Link>
            </div>
            <ul className={styles.flexcenter}>
                <li>
                    <NavLink exact className={({ isActive }) =>
                        isActive ? styles.active : undefined
                    } to="/events/">Home</NavLink>
                </li>
                <li>
                    <NavLink exact className={({ isActive }) =>
                        isActive ? styles.active : undefined
                    } to="/media/projects">Server</NavLink>
                </li>
            </ul>
        </nav>
    )
}

export default EventsNavbar